export default {
    subscribePopup: {
        title: "Подтверди электронный адрес, чтобы получить уведомление о наличии размера",
        description: "Подтверди свой электронный адрес, чтобы получать уведомление о наличии размера. Если он уже подтвержден, то оставляй email, а мы отправим тебе письмо, как только твой размер появится в наличии.",
        sizeTitle: "Размер",
        agreementText: "Я подтверждаю, что мне уже исполнилось 16 лет",
        submitBtnText: "Подписаться",
    },
    successEmailSubscribe: {
        title: "Готово! Ты получишь email, когда твой размер появится на сайте",
        description: "",
        btnText: "Продолжить покупки",
    },
    needConfirmEmailSubscribe: {
        title: "Ждем подтверждение электронного адреса",
        description: "Проверь свою почту: мы отправили письмо с подтверждением подписки.",
        btnText: "Продолжить покупки",
    },
    errorEmailSubscribe: {
        title: "Произошла ошибка",
        description: "Попробуйте воспользоваться функционалом позже",
        btnText: "Продолжить покупки",
    },
};
